export const he = {
    LEFT: 'משמאל: לעבור את היום הקודם.',
    RIGHT: 'נכון: לעבור את היום הבא.',
    DOWN: 'למטה: מעבר שורה הבאה.',
    UP: 'למעלה: לעבור קודם.',
    PGUP: 'במקש pgup: לעבור החודש הקודם.',
    PGDOWN: 'Pgdownqshortcut: לעבור את החודש הבא.',
    HOME: 'בבית: מעבר לשנה הקודמת.',
    END: 'סיום: לעבור את השנה הבאה.',
    ESC: 'Esc/היום/סגור: סגור את לוח השנה.',
    TITLE: 'מקלדת הוראות'
};
